import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {SearchTypeAdvancedRaw, TSearchTypeAdvancedRaw} from './constants';
import {advancedRawRuleDefaults} from './defaults';
import type {AdvancedRawRule} from './types';
import {validateAdvancedRawRule} from './validate';

export class AdvancedRawRuleModel
	extends RuleModel<TSearchTypeAdvancedRaw>
	implements AdvancedRawRule
{
	readonly elementType = SearchTypeAdvancedRaw;
	readonly elementSubType1: 4 = advancedRawRuleDefaults.elementSubType1;
	readonly elementSubType2: 0 = advancedRawRuleDefaults.elementSubType2;
	elementValue1 = advancedRawRuleDefaults.elementValue1;
	readonly elementValue2: '' = advancedRawRuleDefaults.elementValue2;
	readonly elementValue3: '' = advancedRawRuleDefaults.elementValue3;

	get isValid() {
		const validation = validateAdvancedRawRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<AdvancedRawRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...advancedRawRuleDefaults, ...params});
		});

		makeObservable(this, {
			elementValue1: observable,
			isValid: computed,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set raw query
	 * @param elementValue1 raw query
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default AdvancedRawRuleModel;
